import UnlockHomework from './model';

const reviver = ([key, val]) => {
  switch (key) {
    case 'studentId':
      return [key, `${val}`];
    case 'latestUnlockedSequence':
    case 'totalLessonAmount':
      return [key, Number.parseInt(val, 10)];
    default:
      return [key, val];
  }
};

const create = (data) => new UnlockHomework(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/UnlockHomework/create.js